import { defineStore } from 'pinia';
import axios from 'axios';
import type { Organisation } from '@/api/model/Organisation';

export interface OrganisationNotificationData {
    id: number;
    ulid: string;
    source: string;
    notification_type: string;
    severity: string;
    message: string;
    metadata: Record<string, unknown> | null;
    entity_type: string | null;
    entity_id: number | null;
    entity_ulid: string | null;
    created_at: string;
    updated_at: string;
}

interface PaginatedResponse {
    data: OrganisationNotificationData[];
    meta: { total: number };
}

interface NotificationState {
    organisationNotifications: OrganisationNotificationData[];
    totalCount: number;
    loading: boolean;
}

export const useNotificationStore = defineStore('notification', {
    state: (): NotificationState => ({
        organisationNotifications: [],
        totalCount: 0,
        loading: false,
    }),
    actions: {
        async fetchOrganisationNotifications(organisation: Organisation) {
            if (!organisation?.ulid) {
                this.organisationNotifications = [];
                this.totalCount = 0;
                return;
            }

            this.loading = true;
            try {
                const response = await axios.get<PaginatedResponse>(
                    `/api/organisations/${organisation.ulid}/notifications`,
                );
                this.organisationNotifications = response.data.data;
                this.totalCount = response.data.meta.total;
            } catch {
                this.organisationNotifications = [];
                this.totalCount = 0;
            } finally {
                this.loading = false;
            }
        },
        clearAll() {
            this.organisationNotifications = [];
            this.totalCount = 0;
        },
    },
});
